
<div>
  <slot></slot>
  <p v-if="!hasARelationOfCorrectType">Please create a <b>{{ObjectModelRelationDefinition.getDisplayName(ObjectModelRelationType.OneToOne)}}</b> or <b>{{ObjectModelRelationDefinition.getDisplayName(ObjectModelRelationType.ManyToOne)}}</b> relationship to configure this field.</p>
</div>
